import { type ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import styles from './JobProgressionBillingModal.module.css'
import {
  Section,
  SectionContent,
  SectionHeader,
  useSection,
} from '@/components/Section'

export interface JobProgressionBillingModalProps {
  showing: boolean
  onClose: () => unknown
  onSave: () => unknown
  /**
   * The progression and step selectors.
   */
  fields?: ReactNode
  /**
   * A `ProgressionStepSection` per selected step.
   */
  children?: ReactNode
  testId?: string
}

export function JobProgressionBillingModal({
  showing,
  onClose,
  onSave,
  fields,
  children,
  testId,
}: JobProgressionBillingModalProps) {
  return (
    <ModalSheet showing={showing}>
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent leftAligned={true}>
        <ModalSheetSection horizontallySpaced>
          <ModalSheetContentTitle>
            Select job progression
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Add pricing to one or more job progression steps
          </ModalSheetContentDescription>

          {fields}
        </ModalSheetSection>

        {children}
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" variant="default" onPress={onClose} />
          <Button
            label="Save"
            variant="primary"
            onPress={onSave}
            testId={testId ? `${testId}-submit-button` : undefined}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}

export interface ProgressionStepSectionProps {
  name: string
  /**
   * The step's price inputs.
   */
  children?: ReactNode
}

export function ProgressionStepSection({
  name,
  children,
}: ProgressionStepSectionProps) {
  const sectionProps = useSection(false)

  return (
    <Section {...sectionProps}>
      <SectionHeader>{name}</SectionHeader>

      <SectionContent>
        <div className={styles.stepContent}>{children}</div>
      </SectionContent>
    </Section>
  )
}
